import React from "react";
import { useTranslation } from "react-i18next";

import "./LatestNewsPage.css";
import { IMAGES } from "../utils/GetImages";
import { getTranslation } from "../utils/translation";
import { getPDFUrls } from "../utils/config";

export default function LatestNewsPage() {
  const { i18n } = useTranslation();
  const pdfUrls = getPDFUrls();

  const LatestNewsImg1 = IMAGES["LatestNewsPage-Img1.png"];
  const LatestNewsImg2 = IMAGES["LatestNewsPage-Img2.png"];
  const LatestNewsImg3 = IMAGES["LatestNewsPage-Img3.png"];
  const LatestNewsImg4 = IMAGES["LatestNewsPage-Img4.png"];

  return (
    <div className="latest-news-background">
      <div className="latest-news-container">
        <h2 className="latest-news-page-title">
          {getTranslation(i18n, "latestNewsPage.pageTitle")}
        </h2>
        <section id="news">
          <div className="news-card">
            <img
              src={LatestNewsImg1}
              alt="App Preview"
              className="news-card-image"
            />
            <div className="news-card-content">
              <h2>{getTranslation(i18n, "latestNewsPage.news1.title")}</h2>
              <p>{getTranslation(i18n, "latestNewsPage.news1.content")}</p>
            </div>
          </div>
          <div className="news-card reverse">
            <img
              src={LatestNewsImg2}
              alt="App Preview"
              className="news-card-image"
            />
            <div className="news-card-content">
              <h2>{getTranslation(i18n, "latestNewsPage.news2.title")}</h2>
              <p>{getTranslation(i18n, "latestNewsPage.news2.content")}</p>
            </div>
          </div>
          <div className="news-card">
            <img
              src={LatestNewsImg3}
              alt="App Preview"
              className="news-card-image"
            />
            <div className="news-card-content">
              <h2>{getTranslation(i18n, "latestNewsPage.news3.title")}</h2>
              <p>{getTranslation(i18n, "latestNewsPage.news3.content")}</p>
            </div>
          </div>
          <div className="news-card reverse">
            <img
              src={LatestNewsImg4}
              alt="App Preview"
              className="news-card-image"
            />
            <div className="news-card-content">
              <h2>{getTranslation(i18n, "latestNewsPage.news4.title")}</h2>
              <p>{getTranslation(i18n, "latestNewsPage.news4.content")}</p>
            </div>
          </div>
        </section>

        {/* PDF View More Section */}
        {pdfUrls.latestNews && (
          <div className="pdf-view-more-section">
            <div className="pdf-view-more-content">
              <h3 className="pdf-view-more-title">
                {getTranslation(i18n, "latestNewsPage.viewMore") || "View More"}
              </h3>
              <p className="pdf-view-more-description">
                {getTranslation(i18n, "latestNewsPage.viewMoreDescription") ||
                  "Download our latest news PDF for more detailed information"}
              </p>
              <a
                href={pdfUrls.latestNews}
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-view-more-button"
              >
                📄{" "}
                {getTranslation(i18n, "latestNewsPage.downloadPDF") ||
                  "Download PDF"}
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
